import { IncidentTypeStatus } from '@features/siteStatusV2/constants/report';

const MapIncidentTypeStatusToDisplay: Record<IncidentTypeStatus, string> = {
  [IncidentTypeStatus.UNITARY_SIGNALING]: 'report.incidentType.unitarySignaling',
  [IncidentTypeStatus.COLLECTIVE_SIGNALING]: 'report.incidentType.collectiveSignaling',
  [IncidentTypeStatus.EXPERTISE]: 'report.incidentType.expertise',
  [IncidentTypeStatus.SIGNALING]: 'report.incidentType.signaling',
  [IncidentTypeStatus.NO_STATUS]: '-'
};

export default MapIncidentTypeStatusToDisplay;
